import React from 'react';

import withFormField from '@skippay/core/decorators/withFormField';

import AuthField from 'components/AuthField';
import TextInput from 'form-controls/TextInput';

const AuthTextField = withFormField(function AuthTextField(props) {
	const { formFieldProps, input, wide, ...otherProps } = props;

	return (
		<AuthField {...formFieldProps} wide={wide}>
			<TextInput
				{...otherProps}
				{...input}
				disabled={formFieldProps.isDisabled}
				hasError={formFieldProps.isTouched && formFieldProps.hasError}
				id={formFieldProps.id}
				readOnly={formFieldProps.isReadOnly}
				hasSensitiveContent
			/>
		</AuthField>
	);
});

AuthTextField.propTypes = {};

export default AuthTextField;
